// extracted by mini-css-extract-plugin
export default {"moveVolumesBetweenSeasonsForm":"MoveVolumesBetweenSeasons_moveVolumesBetweenSeasonsForm__p82oM"};